








import { Component, Prop, Vue, Provide } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  // 接收附件的传值，需加上@Prop() 修饰符
  @Prop() private msg!: string;
  private childValue: string = '我是子组件的数据';

  private childClick() {
    // childByValue是在父组件on监听的方法
    // 第二个参数this.childValue是需要传的值
    this.$emit('childByValue', this.childValue);
  }
}
